// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file calendar/v1/service.proto (package calendar.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message calendar.v1.GetIcalSubscriptionUrlRequest
 */
export class GetIcalSubscriptionUrlRequest extends Message<GetIcalSubscriptionUrlRequest> {
  constructor(data?: PartialMessage<GetIcalSubscriptionUrlRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "calendar.v1.GetIcalSubscriptionUrlRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIcalSubscriptionUrlRequest {
    return new GetIcalSubscriptionUrlRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIcalSubscriptionUrlRequest {
    return new GetIcalSubscriptionUrlRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIcalSubscriptionUrlRequest {
    return new GetIcalSubscriptionUrlRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIcalSubscriptionUrlRequest | PlainMessage<GetIcalSubscriptionUrlRequest> | undefined, b: GetIcalSubscriptionUrlRequest | PlainMessage<GetIcalSubscriptionUrlRequest> | undefined): boolean {
    return proto3.util.equals(GetIcalSubscriptionUrlRequest, a, b);
  }
}

/**
 * @generated from message calendar.v1.GetIcalSubscriptionUrlResponse
 */
export class GetIcalSubscriptionUrlResponse extends Message<GetIcalSubscriptionUrlResponse> {
  /**
   * @generated from field: optional string url = 1;
   */
  url?: string;

  constructor(data?: PartialMessage<GetIcalSubscriptionUrlResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "calendar.v1.GetIcalSubscriptionUrlResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIcalSubscriptionUrlResponse {
    return new GetIcalSubscriptionUrlResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIcalSubscriptionUrlResponse {
    return new GetIcalSubscriptionUrlResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIcalSubscriptionUrlResponse {
    return new GetIcalSubscriptionUrlResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIcalSubscriptionUrlResponse | PlainMessage<GetIcalSubscriptionUrlResponse> | undefined, b: GetIcalSubscriptionUrlResponse | PlainMessage<GetIcalSubscriptionUrlResponse> | undefined): boolean {
    return proto3.util.equals(GetIcalSubscriptionUrlResponse, a, b);
  }
}

/**
 * @generated from message calendar.v1.EnableIcalSubscriptionRequest
 */
export class EnableIcalSubscriptionRequest extends Message<EnableIcalSubscriptionRequest> {
  constructor(data?: PartialMessage<EnableIcalSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "calendar.v1.EnableIcalSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnableIcalSubscriptionRequest {
    return new EnableIcalSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnableIcalSubscriptionRequest {
    return new EnableIcalSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnableIcalSubscriptionRequest {
    return new EnableIcalSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EnableIcalSubscriptionRequest | PlainMessage<EnableIcalSubscriptionRequest> | undefined, b: EnableIcalSubscriptionRequest | PlainMessage<EnableIcalSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(EnableIcalSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message calendar.v1.EnableIcalSubscriptionResponse
 */
export class EnableIcalSubscriptionResponse extends Message<EnableIcalSubscriptionResponse> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<EnableIcalSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "calendar.v1.EnableIcalSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnableIcalSubscriptionResponse {
    return new EnableIcalSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnableIcalSubscriptionResponse {
    return new EnableIcalSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnableIcalSubscriptionResponse {
    return new EnableIcalSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EnableIcalSubscriptionResponse | PlainMessage<EnableIcalSubscriptionResponse> | undefined, b: EnableIcalSubscriptionResponse | PlainMessage<EnableIcalSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(EnableIcalSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message calendar.v1.DisableIcalSubscriptionRequest
 */
export class DisableIcalSubscriptionRequest extends Message<DisableIcalSubscriptionRequest> {
  constructor(data?: PartialMessage<DisableIcalSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "calendar.v1.DisableIcalSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DisableIcalSubscriptionRequest {
    return new DisableIcalSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DisableIcalSubscriptionRequest {
    return new DisableIcalSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DisableIcalSubscriptionRequest {
    return new DisableIcalSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DisableIcalSubscriptionRequest | PlainMessage<DisableIcalSubscriptionRequest> | undefined, b: DisableIcalSubscriptionRequest | PlainMessage<DisableIcalSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(DisableIcalSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message calendar.v1.DisableIcalSubscriptionResponse
 */
export class DisableIcalSubscriptionResponse extends Message<DisableIcalSubscriptionResponse> {
  constructor(data?: PartialMessage<DisableIcalSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "calendar.v1.DisableIcalSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DisableIcalSubscriptionResponse {
    return new DisableIcalSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DisableIcalSubscriptionResponse {
    return new DisableIcalSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DisableIcalSubscriptionResponse {
    return new DisableIcalSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DisableIcalSubscriptionResponse | PlainMessage<DisableIcalSubscriptionResponse> | undefined, b: DisableIcalSubscriptionResponse | PlainMessage<DisableIcalSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(DisableIcalSubscriptionResponse, a, b);
  }
}

